import { BreakpointProp } from '../../types/styles';
import { isBreakpointObject } from '../../utils';
import useBreakpoint from '../useBreakpoint';

const useBreakpointProp = <T>(prop: BreakpointProp<T>): T => {
  const breakpoint = useBreakpoint();

  return isBreakpointObject<T>(prop) ? prop[breakpoint] : prop;
};

export default useBreakpointProp;
